
export class GetAllAppointmentParticipantCurrentUserRequestDto{
  upcomingAppointments: boolean;
}
